import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AccessRequestService } from './accessrequest.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../Shared/commonservice';
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: 'app-accessrequest',
  templateUrl: './accessrequest.component.html',
  styleUrls: ['./accessrequest.component.css']
})
export class AccessrequestComponent implements OnInit {

  accessForm: FormGroup;
  postresult: boolean;  
  submitted = false;
  loading = false;
  error: string;
  constructor(private formBuilder: FormBuilder,
    private accessrequestservice: AccessRequestService,   
    private toastr: ToastrService, private router: Router,
    private commonService: CommonService, private SpinnerService: NgxSpinnerService, private route: ActivatedRoute
  ) {

  }
  ngOnInit() {

    let email = '';
    let firstname = '';
    let lastname = '';
    this.route.queryParams.subscribe(params => {
      email = params['email'];
      firstname = params['firstname'];
      lastname = params['lastname'];
    });



    this.accessForm = this.formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      emailid: ['', [Validators.required, Validators.email]],
      comments: ['']
    });

    this.accessForm.patchValue({
      emailid: email == undefined ? '' : email,
      firstname: firstname == undefined ? '' : firstname,
      lastname: lastname == undefined ? '' : lastname,
    });


  }
  get f() { return this.accessForm.controls; }


  onSubmit(http: HttpClient) {
    this.submitted = true;
    this.loading = true;
    if (this.accessForm.invalid) {
      return;
    }
    if (this.f.firstname.value.trim() != "" && this.f.lastname.value.trim() != "") {
      if (this.f.firstname.value == this.f.lastname.value) {
        this.toastr.error("First Name and Last Name should not be same");
        this.loading = true;
        return;
      }
      this.SpinnerService.show();
      var userData = this.f.firstname.value + ',' + this.f.lastname.value + ',' + this.f.emailid.value + ',' + this.f.comments.value;
      this.commonService.sendemail(userData, "accessrequest").toPromise().then(res => {
        this.accessrequestservice.Addaccessrequest(this.f.firstname.value, this.f.lastname.value, this.f.emailid.value, this.f.comments.value).subscribe(res => {
          if (res.status == 200) {
            this.postresult = true;
            this.submitted = false;
            this.accessForm.reset();
            this.router.navigate(['/login']);
          };
          this.SpinnerService.hide();
          this.toastr.success('Access Request has been added successfully.');
        },
          error => {
            this.toastr.error(error.error);
            this.SpinnerService.hide();
          })
        this.loading = false;
      },
        error => {
          this.toastr.error(error.error);
          this.SpinnerService.hide();
          return;
        });
    }



  } 
}
